import CreateValueModule from "@/redux/create-value-module";

import {
    $AccountFormsModuleName,
    TAccountFormsState
} from "./accountForms.types";

const { actions } = CreateValueModule<TAccountFormsState>(
    $AccountFormsModuleName,
    {
        loginComponent: false,
        registerComponent: false
    }
);

export const update = actions.update;
